const constants = {
  STOPS_MENU_ACTION_LIST: {
    ADD_PRO_NOTES: "ADD_PRO_NOTES",
    PROCESS_DELIVERY: "PROCESS_DELIVERY",
    PROCESS_PICKUP: "PROCESS_PICKUP",
    REMOVE_PRO: "REMOVE_PRO",
    MARK_AS_NEXT_STOP: "MARK_AS_NEXT_STOP",
    ADD_PRO_TO_PICKUP: "ADD_PRO_TO_PICKUP",
  },
  MAX_LENGTH_CONSTRAINTS: {
    ADD_PRO_NOTES: {
      COMMENT: 6000
    }
  }
};

export default constants;
